module.exports = __webpack_public_path__ + "static/media/deactive_sound_icon.b8631c31.svg";